import { render, staticRenderFns } from "./MspAttivitaDetail.vue?vue&type=template&id=4679c01c"
import script from "./MspAttivitaDetail.vue?vue&type=script&lang=js"
export * from "./MspAttivitaDetail.vue?vue&type=script&lang=js"
import style0 from "./MspAttivitaDetail.vue?vue&type=style&index=0&id=4679c01c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports